type Listener = () => void;

let current: HTMLAudioElement | null = null;
let recording = false;
const listeners = new Set<Listener>();

const notify = () => listeners.forEach((l) => l());

export const voicePlayback = {
  claim(audio: HTMLAudioElement) {
    if (current && current !== audio) {
      try {
        current.pause();
      } catch {
        // noop
      }
    }
    current = audio;
    notify();
  },
  isCurrent(audio: HTMLAudioElement) {
    return current === audio;
  },
  isRecording() {
    return recording;
  },
  release(audio: HTMLAudioElement) {
    if (current === audio) {
      current = null;
      notify();
    }
  },
  setRecording(value: boolean) {
    if (recording === value) return;
    recording = value;
    if (value && current) {
      try {
        current.pause();
      } catch {
        // noop
      }
      current = null;
    }
    notify();
  },
  stopAll() {
    if (current) {
      try {
        current.pause();
      } catch {
        // noop
      }
      current = null;
      notify();
    }
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
